import {productColors} from "@irati/ui/src/global/colors"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"

import {IconTypes} from "@irati-native/ui-kit/Icon/svg/enums"
import Products from "../enums/Products"

type ProductList = {
  [Product in Products]: {
    color: string,
    icon: string,
    text: string,
    title: string
  }
}

const productsUI = (formatMessage: FormatMessage): ProductList => ({
  [Products.perks]: {
    color: productColors.perks,
    icon: IconTypes.perks,
    text: formatMessage({id: "platform.products.perks.text"}),
    title: formatMessage({id: "platform.products.perks.title"})
  },
  [Products.medical]: {
    color: productColors.medical,
    icon: IconTypes.medical,
    text: formatMessage({id: "platform.products.medical.text"}),
    title: formatMessage({id: "platform.products.medical.title"})
  },
  [Products.recognition]: {
    color: productColors.recognition,
    icon: IconTypes.celebration,
    text: formatMessage({id: "platform.products.recognition.text"}),
    title: formatMessage({id: "platform.products.recognition.title"})
  },
  [Products.wellness]: {
    color: productColors.wellness,
    icon: IconTypes.wellness,
    text: formatMessage({id: "platform.products.wellness.text"}),
    title: formatMessage({id: "platform.products.wellness.title"})
  },
  [Products.rewards]: {
    color: productColors.rewards,
    icon: IconTypes.celebration,
    text: formatMessage({id: "platform.products.rewards.text"}),
    title: formatMessage({id: "platform.products.rewards.title"})
  }
})

export default productsUI
